import { ChequeGiroClearingModel } from 'api-hooks/transactions/cheque-giro-clearing';
import { Form, FormState, Input } from 'components/elements';
import FormHeader from 'components/widgets/form-header';
import BankAccountSelectInput from 'legacy-modules/master/bank-account/components/select-input';
import ChequeGiroSelectInput from 'legacy-modules/master/cheque-giro/components/select-input';
import {
  HalfContainer,
  SectionContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useForm } from 'react-hook-form';

import ClearingSection from './clearing-section';
import { ChequeGiroClearingFormType } from './form-type';
import useGetDefaultValues from '../hooks/use-get-default-values';

interface Props {
  chequeGiroClearing?: ChequeGiroClearingModel;
}

export default function ChequeGiroClearingForm(props: Props) {
  const { t } = useTranslation();
  const { asPath } = useRouter();
  const { chequeGiroClearing } = props;

  const defaultValues = useGetDefaultValues(chequeGiroClearing);

  const methods = useForm<ChequeGiroClearingFormType>({
    defaultValues,
    mode: 'onChange',
  });

  const customViewName =
    chequeGiroClearing &&
    [t('common:cheque_giro_clearing'), chequeGiroClearing.referenceNumber].join(
      ' - ',
    );

  return (
    <Form
      methods={methods}
      onSubmit={() => {}}
      defaultEditable={!chequeGiroClearing}
      style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      customViewName={customViewName}
      keyName={asPath}
    >
      <FormState>
        {({ editable }) => (
          <FormHeader
            data={chequeGiroClearing}
            noDelete
            noSubmit
            noEdit
            title={
              chequeGiroClearing
                ? customViewName ?? t('common:cheque_giro_clearing')
                : t('common:add_extra', {
                    extra: t('common:cheque_giro_clearing'),
                  })
            }
          />
        )}
      </FormState>
      <div>
        <SectionContainer>
          <HalfContainer>
            <ChequeGiroSelectInput name="chequeGiro" disabled />
          </HalfContainer>
          <HalfContainer>
            <Input
              type="text"
              name="type"
              label={t('common:type')}
              placeholder={t('common:type')}
              disabled
            />
          </HalfContainer>
        </SectionContainer>
        <SectionContainer>
          <HalfContainer>
            <Input
              type="text"
              name="referenceNumber"
              label={t('common:reference')}
              placeholder={t('common:reference')}
              disabled
            />
          </HalfContainer>
          <HalfContainer>
            <Input
              type="date-time"
              name="issuedAt"
              label={t('common:issue_at')}
              placeholder={t('common:issue_at')}
              disabled
            />
          </HalfContainer>
        </SectionContainer>
        <SectionContainer>
          <HalfContainer>
            <Input
              type="date-time"
              name="availableAt"
              label={t('common:available_at')}
              placeholder={t('common:available_at')}
              disabled
            />
          </HalfContainer>
          <HalfContainer>
            <Input
              type="date-time"
              name="expiredAt"
              label={t('common:expiry_at')}
              placeholder={t('common:expiry_at')}
              disabled
            />
          </HalfContainer>
        </SectionContainer>
        <SectionContainer>
          <HalfContainer>
            <Input
              type="text"
              name="status"
              label={t('common:status')}
              placeholder={t('common:status')}
              disabled
            />
          </HalfContainer>
          <HalfContainer>
            <BankAccountSelectInput name="bankAccount" disabled />
          </HalfContainer>
        </SectionContainer>
        <SeparatorVertical $margin={16} />
        <ClearingSection chequeNoteId={chequeGiroClearing?.id} />
      </div>
    </Form>
  );
}
